// AUTO-GENERATED: 2025-10-28T19:10:34.719848Z
// 🍜 Korean recipes

export const koreanRecipes = [
{
    name: "Bibimbap",
    cuisine: "Korean",
    ingredients: ["rice", "beef", "spinach", "carrots", "mushrooms", "bean sprouts", "egg"],
    sauces: ["gochujang", "sesame oil", "soy sauce", "garlic"],
    instructions: "Cook rice. Sauté beef with soy sauce and garlic. Blanch spinach, squeeze dry, season with sesame oil. Sauté carrots, mushrooms, bean sprouts separately. Arrange rice in bowl, top with vegetables and beef in sections. Fry egg sunny-side up, place on top. Serve with gochujang sauce to mix at table.",
    time: "40 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Kimchi Fried Rice",
    cuisine: "Korean",
    ingredients: ["rice", "kimchi", "eggs", "scallions", "pork belly"],
    sauces: ["gochujang", "sesame oil", "soy sauce"],
    instructions: "Use day-old rice. Chop kimchi and pork belly. Heat pan, fry pork until crispy. Add kimchi, stir-fry 2 minutes. Add rice, break up clumps. Stir-fry 5 minutes. Add kimchi juice, gochujang, soy sauce. Mix well. Push rice to side, fry eggs. Serve rice topped with fried egg and sesame seeds. Drizzle with sesame oil.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Bulgogi",
    cuisine: "Korean",
    ingredients: ["beef sirloin", "onion", "scallions", "mushrooms"],
    sauces: ["soy sauce", "sugar", "sesame oil", "garlic", "ginger", "pear juice"],
    instructions: "Slice beef thinly against grain. Marinate with soy sauce, sugar, sesame oil, garlic, ginger, pear juice for 2+ hours. Heat grill or pan to high. Cook beef with onions and mushrooms 3-4 minutes until caramelized. Don't overcrowd pan. Garnish with scallions and sesame seeds. Serve with lettuce wraps, rice, and banchan.",
    time: "30 min + marinade",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Korean Fried Chicken",
    cuisine: "Korean",
    ingredients: ["chicken wings", "flour", "cornstarch", "eggs"],
    sauces: ["gochujang", "honey", "soy sauce", "garlic", "ginger", "sesame seeds"],
    instructions: "Coat chicken in flour-cornstarch mixture. Double fry: first at 325°F for 8 minutes, rest 5 minutes, then fry again at 375°F for 5-6 minutes until extra crispy. Make sauce by simmering gochujang, honey, soy sauce, garlic, and ginger. Toss hot chicken in sauce. Garnish with sesame seeds and scallions. Serve immediately.",
    time: "45 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Japchae",
    cuisine: "Korean",
    ingredients: ["sweet potato noodles", "beef", "spinach", "carrots", "mushrooms", "onion"],
    sauces: ["soy sauce", "sugar", "sesame oil", "garlic"],
    instructions: "Soak noodles in hot water until soft. Marinate beef with soy sauce, sugar, garlic. Stir-fry vegetables separately, set aside. Stir-fry beef. Cook noodles in boiling water 7 minutes, drain. Toss noodles with soy sauce, sugar, sesame oil. Combine everything, stir-fry together 2 minutes. Garnish with sesame seeds and scallions.",
    time: "35 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Tteokbokki",
    cuisine: "Korean",
    ingredients: ["rice cakes", "fish cakes", "cabbage", "scallions", "eggs"],
    sauces: ["gochujang", "gochugaru", "soy sauce", "sugar"],
    instructions: "Soak rice cakes in warm water. Make sauce with gochujang, gochugaru, soy sauce, sugar, and water. Bring to boil. Add rice cakes and fish cakes. Simmer 10-15 minutes, stirring occasionally, until sauce thickens and coats rice cakes. Add cabbage and scallions, cook 2 more minutes. Optionally top with boiled egg. Serve hot.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Sundubu Jjigae",
    cuisine: "Korean",
    ingredients: ["soft tofu", "pork belly", "zucchini", "mushrooms", "onion", "egg"],
    sauces: ["gochugaru", "soy sauce", "garlic", "sesame oil"],
    instructions: "Sauté pork belly with garlic in stone pot. Add gochugaru, stir. Add anchovy broth, soy sauce, bring to boil. Add zucchini, mushrooms, onions. Simmer 5 minutes. Gently add soft tofu in large spoonfuls. Simmer 5 more minutes. Crack egg on top, cover until egg sets. Drizzle with sesame oil. Serve bubbling hot with rice.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Galbi",
    cuisine: "Korean",
    ingredients: ["beef short ribs", "onion", "scallions"],
    sauces: ["soy sauce", "sugar", "sesame oil", "garlic", "ginger", "pear juice", "mirin"],
    instructions: "Score meat on ribs. Mix marinade: soy sauce, sugar, sesame oil, garlic, ginger, pureed pear, mirin. Marinate ribs 4+ hours or overnight. Grill over high heat 3-4 minutes per side, basting with marinade. Meat should be caramelized outside, medium inside. Garnish with scallions. Serve with lettuce wraps, ssamjang, and rice.",
    time: "30 min + marinade",
    difficulty: "Medium",
    points: 100,
    servings: 2,
    special: true
  },
{
    name: "Pajeon",
    cuisine: "Korean",
    ingredients: ["flour", "eggs", "scallions", "seafood", "kimchi"],
    sauces: ["soy sauce", "rice vinegar", "sesame oil", "gochugaru"],
    instructions: "Make batter with flour, eggs, water. Add chopped scallions, seafood (shrimp, squid), and optional kimchi. Heat oil in pan until very hot. Pour batter, spread thin. Fry 4-5 minutes until bottom is golden and crispy. Flip, fry other side. Cut into squares. Make dipping sauce with soy sauce, vinegar, sesame oil, gochugaru. Serve hot.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Kimchi Jjigae",
    cuisine: "Korean",
    ingredients: ["kimchi", "pork belly", "tofu", "onion", "scallions"],
    sauces: ["gochugaru", "soy sauce", "sesame oil"],
    instructions: "Sauté pork belly until crispy. Add chopped kimchi, stir-fry 3-4 minutes. Add gochugaru and kimchi juice. Add water or broth, bring to boil. Simmer 15 minutes. Add tofu cubes and onions. Simmer 5 more minutes. Season with soy sauce. Garnish with scallions. Drizzle with sesame oil. Serve bubbling hot with rice.",
    time: "30 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  }
];
